import { ImageInput } from "~/components/file-input";
import { FormField } from "~/components/ui/form-field";
import type { CoachImagePurpose } from "~/lib/shared/coach-image-types";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function ImageField({
  purpose,
  label,
  required,
  helpText,
  recommendedDimensions,
}: {
  purpose: CoachImagePurpose;
  label?: string;
  required?: boolean;
  helpText?: string;
  recommendedDimensions?: { width: number; height: number };
}) {
  const field = useFieldContext<string | null | undefined>();
  const error = useFieldError(field.name);
  return (
    <FormField
      label={label}
      required={required}
      helpText={helpText}
      error={error}
    >
      <ImageInput
        name={field.name}
        purpose={purpose}
        type="url"
        value={field.state.value ?? ""}
        onChange={(e) => field.handleChange(e.target.value)}
        recommendedDimensions={recommendedDimensions}
      />
    </FormField>
  );
}
